// extracted by mini-css-extract-plugin
export default {"container":"SummaryHistory_container__uKezP","wrapper":"SummaryHistory_wrapper__XpJyQ","divUp":"SummaryHistory_divUp__Y1lAk","pageTitle":"SummaryHistory_pageTitle__mFFKN"};